






























































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import ImportDialog from "./children/ImportDialog.vue";
import { uploader } from "./utils/uploader.js";
import { pagination, loadingCatch, loading } from "@root/lib/decorator";
import { sleep } from "@root/lib/utils";

const Root = namespace("root");

@Component({
  components: {
    ImportDialog
  }
})
@pagination("getData", {
  pageSize: 5
})
@loading()
export default class ImportComponent extends Vue {
  @Prop({ type: Array, required: true }) tabOptions;
  @Prop({ type: String, default: "Import" }) pageTitle;
  @Prop({ type: String, default: "" }) pageSubTitle;
  @Prop({ type: Boolean, default: false }) defaultOrgDisabled; // default org 不可用

  @Root.Action queryImportFileDetail;
  @Root.Action createImportFile;
  @Root.Action downTemplate;
  @Root.Action queryImportFile;

  activeName = "";
  category = "";
  dataList = [];
  total = 0;
  hasAlarted = false;

  tabIndex = 0;

  idData: any = null;
  detailData: any | null = null;
  // timeID: any = null;
  tag: any = {
    tagType: "success",
    name: "Success"
  };
  timeEr: any = null;
  timeFlag: any = null;
  loading: boolean = false;
  uploadFilePath: string = "";

  mounted() {
    this.pageInit();
  }

  destroyed() {
    window.clearInterval(this.timeEr);
  }

  beforeRouteLeave(to, from, next) {
    if (to.params.name !== from.params.name) {
      window.clearInterval(this.timeEr);
      next();
    }
  }

  pageInit() {
    // set default active name
    if (!this.tabOptions.length) {
      return;
    }

    const { name, category } = this.tabOptions[0];

    this.activeName = name;
    this.category = category.toLowerCase();

    this.getData();
  }

  async getData() {
    const { category, pageSize, pageNum } = this as any;
    const { dataList, total } = await this.queryImportFile({
      pageInput: {
        pageNum,
        pageSize
      },
      condition: {
        category
        // orgCode
      }
    });

    this.dataList = dataList;
    this.total = total;
  }

  // tab switch
  async onTabSwitch({ index }) {
    this.category = this.tabOptions[index].category;
    (this as any).handlePageChange(1);
  }

  // download template
  async onTempDownloadClick(template) {
    let url = "";
    if (typeof template === "string") {
      url = template;
    } else {
      url = await this.downTemplate(template);
    }

    if (!url) return;

    this.createDownA(url);
  }

  createDownA(url) {
    let eleLink = document.createElement("a");
    eleLink.download = url;
    eleLink.style.display = "none";
    eleLink.href = url;
    document.body.appendChild(eleLink);
    eleLink.click();
    document.body.removeChild(eleLink);
  }

  // 选择文件
  handleSelectFile() {
    // 调用 uploader.js 中选择文件的 method
    uploader.selectFile(file => {
      this.uploadFilePath = file["name"];
    });
  }

  // remove result
  handleRemoveFile() {
    uploader.removeFile();
    this.uploadFilePath = "";
  }

  // 刷新结果列表
  async handleRefresh() {
    try {
      this.loading = true;
      await this.getData();
      await sleep(1500);
    } catch (err) {
      console.log(err);
    } finally {
      this.loading = false;
    }
  }

  async beforeUpload({ name }) {
    const fetchData = {
      category: this.category,
      name,
      // orgCode,
      metadata: [
        {
          name: "locale",
          value: localStorage.getItem("locale") || "en"
        },
        {
          name: "relationOrgCode",
          value: "default"
        }
      ]
    };

    return await this.createImportFile(fetchData);
  }

  async successCallback() {
    // 第一次上传文件 会弹出提示文本 只提示一次
    if (!this.hasAlarted) {
      this.$alert((this as any).$t("Root.Import.importing"), {
        confirmButtonText: (this as any).$t("Root.Import.got_it")
      });
    } else {
      this.hasAlarted = true;
    }

    // reset fetch data
    (this as any).handlePageChange(1);

    // hiddle select file path
    this.uploadFilePath = "";
  }

  onUploadClick() {
    uploader.setOption({
      beforeUploadCallback: this.beforeUpload,
      successCallback: this.successCallback
    });

    uploader.upload();
  }

  async handleViewRes(row) {
    let {
      importNo = "",
      createTime = "",
      name = "",
      errorCount = 0,
      totalCount = 0
    } = row;

    this.detailData = {
      createTime,
      name,
      errorCount,
      importNo,
      successCount: totalCount - errorCount
    };

    (this.$refs.$importDialog as any).dialogTableVisible = true;
  }

  // utils
  renderHeader(h, { column, $index }) {
    return h("div", [
      h("span", column.label + "  ", {
        align: "left"
      }),
      h(
        "el-popover",
        {
          props: {
            placement: "top-start",
            width: "220",
            trigger: "hover"
          }
        },
        [
          h("p", "When the import is running,you can not view result", {
            class: "text-align: right; margin: 0"
          }),
          h("i", {
            class: "el-icon-question",
            style: "color:#ccc,margin:18px",
            slot: "reference"
          })
        ]
      )
    ]);
  }

  statusToType(type) {
    const key = type.toLocaleUpperCase();
    const map = {
      FINISHED: "success",
      FAILED: "danger",
      PROCESSING: "warning"
    };
    return map[key] || "danger";
  }
}
